import { useContext } from "react";
import { ThemeContext } from "../context/ThemeContext";
import { useLanguage } from "../context/LanguageContext";
import { useThemeColors } from "../context/ThemeColorContext";
import { useStaticTexts } from "../context/StaticTextContext";

const Header = () => {
  const { lang, changeLang } = useLanguage();
  const { darkMode, setDarkMode } = useContext(ThemeContext);
  const {
    // darkSecondary,
    // lightSecondary,
    darkPrimary,
    lightSecondary,
    darkAccent,
    lightAccent,
    darkText,
    lightText,
  } = useThemeColors();

  const staticTexts = useStaticTexts();

  if (!staticTexts || Object.keys(staticTexts).length === 0) {
    return null;
  }

  const {
    logo,
    site_name,
    toggle_theme_dark,
    toggle_theme_light,
  } = staticTexts;

  const textColor = darkMode ? darkText : lightText;

  return (
    <header
      className="p-4 shadow-md flex justify-between items-center"
      style={{
        backgroundColor: darkMode ? darkPrimary : lightSecondary,
        color: textColor,
      }}
    >
      <div className="flex items-center gap-4">
        {logo && (
          <img
            src={logo}
            alt="لوگو"
            className="w-10 h-10 rounded-full object-cover"
          />
        )}
        <h1 className="text-xl font-bold" style={{ color: textColor }}>
          {site_name}
        </h1>
      </div>

      <div className="flex gap-2">
        <button
          onClick={() => changeLang(lang === "fa" ? "en" : "fa")}
          className="px-4 py-1 rounded transition hover:opacity-80 text-sm"
          style={{
            backgroundColor: darkMode ? darkAccent : lightAccent,
            color: "#fff",
          }}
        >
          {lang === "fa" ? "EN" : "FA"}
        </button>
        <button
          onClick={() => setDarkMode((prev) => !prev)}
          className="px-4 py-1 rounded transition hover:opacity-80 text-sm"
          style={{
            backgroundColor: darkMode ? darkAccent : lightAccent,
            color: "#fff",
          }}
        >
          {darkMode ? toggle_theme_light : toggle_theme_dark}
        </button>
      </div>
    </header>
  );
};

export default Header;
